import { ROLE_ID_TRASLADO_BODEGAS_LIMITADAS } from '../constants/roleIds'
import type { FlexyAlmacen } from '../types/flexyAlmacenes'

export type TrasladoAlmacenSide = 'origen' | 'destino'

export type TrasladoAlmacenFamily =
  | 'FULFILLMENT'
  | 'XEROX'
  | 'SALDOS'
  | 'DEVOLUCIONES'
  | 'GARANTIAS'

const ORIGEN_ROLE_13: readonly TrasladoAlmacenFamily[] = [
  'SALDOS',
  'DEVOLUCIONES',
  'GARANTIAS'
]

const DESTINO_ROLE_13: readonly TrasladoAlmacenFamily[] = [
  'FULFILLMENT',
  'XEROX',
  'SALDOS',
  'DEVOLUCIONES',
  'GARANTIAS'
]

function normalizeAlmacenText(value: string | undefined): string {
  return (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim()
}

/** Identifica la bodega por código o nombre, sin confundir Exhibición Xerox con Xerox. */
export function resolveTrasladoAlmacenFamily(
  almacen: Pick<FlexyAlmacen, 'codigo' | 'nombre' | 'label'>
): TrasladoAlmacenFamily | null {
  const codigo = normalizeAlmacenText(almacen.codigo)
  const nombre = normalizeAlmacenText(almacen.nombre || almacen.label)

  if (codigo === 'FUL-MDM' || codigo.startsWith('FUL-') || nombre === 'FULFILLMENT' || nombre === 'FULLFILMENT') {
    return 'FULFILLMENT'
  }
  if (codigo === 'XER-MDM' || codigo.startsWith('XER-') || nombre === 'XEROX') {
    return 'XEROX'
  }
  if (codigo === 'SAL-MDM' || codigo.startsWith('SAL-') || nombre === 'SALDOS' || nombre === 'SALDO') {
    return 'SALDOS'
  }
  if (
    codigo === 'DEV-MDM' ||
    codigo.startsWith('DEV-') ||
    nombre.startsWith('DEVOLUC')
  ) {
    return 'DEVOLUCIONES'
  }
  if (codigo.startsWith('GAR') || nombre.startsWith('GARANT')) {
    return 'GARANTIAS'
  }

  return null
}

export function filterAlmacenesForTrasladoRole(
  almacenes: readonly FlexyAlmacen[],
  roleId: number | undefined | null,
  side: TrasladoAlmacenSide
): FlexyAlmacen[] {
  if (roleId !== ROLE_ID_TRASLADO_BODEGAS_LIMITADAS) return [...almacenes]

  const allowed = side === 'origen' ? ORIGEN_ROLE_13 : DESTINO_ROLE_13
  return almacenes.filter((almacen) => {
    const family = resolveTrasladoAlmacenFamily(almacen)
    return family != null && allowed.includes(family)
  })
}

/** Opciones del select: value = idalmacen, label del API, sin el almacén excluido. */
export function selectAlmacenOptions(
  almacenes: readonly FlexyAlmacen[],
  excludeId: number | '' = ''
): FlexyAlmacen[] {
  if (excludeId === '') return [...almacenes]
  return almacenes.filter((almacen) => almacen.value !== excludeId)
}
